var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 130C100.899 130 130 100.899 130 65C130 29.1015 100.899 0 65 0C29.1015 0 0 29.1015 0 65C0 100.899 29.1015 130 65 130Z",
    fill: "#EAECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 130.004H26V45.937C29.6764 45.9328 33.201 44.4706 35.8007 41.871C38.4003 39.2714 39.8625 35.7467 39.8667 32.0703H90.1333C90.1294 33.8915 90.4868 35.6954 91.1846 37.3776C91.8824 39.0598 92.907 40.5869 94.1989 41.8706C95.4825 43.1629 97.0097 44.1877 98.692 44.8857C100.374 45.5837 102.179 45.941 104 45.937V130.004Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9992 88.3969C76.4867 88.3969 85.7992 79.0844 85.7992 67.5969C85.7992 56.1094 76.4867 46.7969 64.9992 46.7969C53.5117 46.7969 44.1992 56.1094 44.1992 67.5969C44.1992 79.0844 53.5117 88.3969 64.9992 88.3969Z",
    fill: "#FF7A7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3539 77.4018L65 70.0479L57.6461 77.4018L55.1948 74.9505L62.5487 67.5966L55.1948 60.2427L57.6461 57.7914L65 65.1453L72.3539 57.7914L74.8052 60.2427L67.4513 67.5966L74.8052 74.9505L72.3539 77.4018Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2661 93.6016H53.7328C52.2969 93.6016 51.1328 94.7656 51.1328 96.2016C51.1328 97.6375 52.2969 98.8016 53.7328 98.8016H76.2661C77.7021 98.8016 78.8661 97.6375 78.8661 96.2016C78.8661 94.7656 77.7021 93.6016 76.2661 93.6016Z",
    fill: "#EAECF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0673 104H45.934C44.498 104 43.334 105.164 43.334 106.6C43.334 108.036 44.498 109.2 45.934 109.2H84.0673C85.5033 109.2 86.6673 108.036 86.6673 106.6C86.6673 105.164 85.5033 104 84.0673 104Z",
    fill: "#EAECF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultError);
export default __webpack_public_path__ + "static/media/DefaultError.8ee59ffe1e245d116ba79020816760e0.svg";
export { ForwardRef as ReactComponent };